export default __webpack_public_path__ + "static/media/Apple MacBook Pro 13-inch.7a10f346.png";